<template>
  <div style="display: flex; justify-content: space-between; background-color: rgb(233, 236, 246)">
    <!-- 选择模板 -->
    <v-dialog v-model="dialog" persistent>
      <div class="card" style="width: 100%;">
        <div
          style="width: 100%; padding-top: 10px; display: flex; justify-content: space-between;  align-items: center; position: sticky; top: 0;background-color: white; z-index: 10; ">
          <div style="flex-grow: 1; text-align: center; margin-right: -70px;">{{ $i18n.t("ppt_add_in_main.template_select_title") }}</div>
          
          <div style="display: flex; align-items: center;">
            <button v-if="showCancelBtn" @click="clearSelected()" style="font-size: 13px; color: rgb(73, 107, 189);">
              {{ $i18n.t("ppt_add_in_main.btn_clear_select_template") }}
            </button>
            <button @click="saveSettings()" style="font-size: 13px; margin-left: 10px; color: rgb(73, 107, 189);">
              {{ $i18n.t("ppt_add_in_main.confirm") }}
            </button>
            <button style="display: flex; margin-left: 5px;" @click="clickCloseSettings()">
              <v-icon >mdi-close</v-icon>
            </button>
          </div>
        </div>
        <v-tabs center-active show-arrows v-model="tab">
          <v-tab v-for="item in templateTypes" :key="item.name">
            {{ item.name }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(item, index) in templateTypes" :key="index">
            <v-card flat>
              <!-- <v-list v-if="item.templates.length > 0" :style="{ maxHeight: listMaxHeight + 'px' }"> -->
                <div v-if="item.templates.length > 0" style="max-height: 400px; overflow-y: auto;">
                   <v-list >
                    <v-list-item-group v-model="selectedItem" color="primary" @change="handleIndexChange">
                      <v-list-item v-for="(template, i) in item.templates" :key="i" 
                        @mouseenter="enter(i)"
                        @mouseleave="leave()">
                        <v-list-item-icon style="position: relative; " >
                          <!-- <v-icon v-text="item.icon"></v-icon> -->
                          <img :src=template.cover alt=""
                            style="width: 216px; height: 121.5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);" />
                          <div  style="position: absolute; top: 0; left: 0; 
                            width: 216px; height: 121.5px; background: rgba(0, 0, 0, 0.4); color: white; 
                            padding: 6px 6px; font-size: 14px" 
                            v-if="showDes && desShowIndex == i && template.des != ''" >
                            {{ template.des }}
                          </div>
                          <!-- <div v-if="item.type === 'semantic_whole' && desShowIndex === i" style="display: flex; gap: 8px; margin-left: 5px; ">
                            <v-icon size="17" color="primary" @click="previewWholeSemanticTemplate(i)"> mdi-eye </v-icon>
                          </div> -->
                        </v-list-item-icon>
                        <v-list-item-content style="margin-left: -22px; ">
                          <!-- <div style="display: flex; align-items: center;"> -->
                            <!-- <div>{{ item.fileName }}</div> -->
                            <!-- <v-icon style="margin-left: 5px;" v-if="item.selected" color="primary">mdi-check</v-icon> -->
                          <!-- </div> -->
                          <!-- <v-list-item-title v-text="item.text"></v-list-item-title> -->
                          <!-- <v-icon color="primary">mdi-check</v-icon> -->
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </div>
             
              <div style="min-height: 150px; display: flex; justify-content: center;  align-items: center;" v-else>
                  {{ $i18n.t("ppt_add_in_main.msg_pls_select_sys_template") }}
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import store from "@store";
import { userKeys, appIds } from "@/service/wd_app_config.js";
import { get, sync } from "vuex-pathify";
import { i18n } from "@/plugins/i18n.js";
import { actionMenuPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
// import { getServiceWindowAvatar } from "@/service/wd_service_com.js";
import { isEqualGuidString } from "@/utils/wd_utils";
import { preViewTemplate, savePreviewTemplateShapeData } from "@/views/gpt/util/gpt_addin_utils";
//例如: import <组件名称> from  <组建路径>

export default {
    //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      dialog: false,
      selectFile: null,
      selectedItem: -1,
      tab: null,
      desShowIndex: -1,
      // 原始模板类型定义
      // rawTemplateTypes: [
      //   {
      //     name: i18n.t('ppt_add_in_main.template_select_tab_name_semantic'),
      //     type: 'semantic_one_page',
      //     templates: []
      //   },
      //   {
      //     name: i18n.t('ppt_add_in_main.template_select_tab_name_sys'),
      //     type: 'sys_one_page',
      //     templates: []
      //   },
      //   // {
      //   //   name: i18n.t('ppt_add_in_main.template_select_tab_name_ent'),
      //   //   type: 'enterprise',
      //   //   templates: []
      //   // },
      //   {
      //     name: i18n.t('ppt_add_in_main.template_select_tab_name_whole'),
      //     type: 'semantic_whole',
      //     templates: []
      //   },  
      // ],
      TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE: 'semantic_whole',
      TEMPLATE_TYPE_NAME_SEMANTIC_ONE_PAGE: 'semantic_one_page',
      TEMPLATE_TYPE_NAME_SYS_ONE_PAGE: 'sys_one_page',
      templateTypes: [
        {
          name: i18n.t('ppt_add_in_main.template_select_tab_name_whole'),
          type: 'semantic_whole',
          templates: []
        },
        {
          name: i18n.t('ppt_add_in_main.template_select_tab_name_semantic'),
          type: 'semantic_one_page',
          templates: []
        },
        {
          name: i18n.t('ppt_add_in_main.template_select_tab_name_sys'),
          type: 'sys_one_page',
          templates: []
        }, 
        // {
        //   name: i18n.t('ppt_add_in_main.template_select_tab_name_ent'),
        //   type: 'enterprise',
        //   templates: []
        // },
      ],
      showDes: false
    };
  },
  //计算机属性 类似与data概念
  computed: {
    ...get("gpt", ["template_title_contents", 'template_semantic' , 'template_semantic_whole', "selectedTaskType"]),
    ...sync("gpt", ["template_title_contents", 'template_semantic', 'template_semantic_whole', "selectedTaskType"]),
    listMaxHeight() {  
      return window.innerHeight - 160;  
    },
    showCancelBtn() {
      return store.get('gpt/currentSelectedTemplateName') != null
    },
    // isWholeTemplate() {
    //   return this.selectedTaskType?.id === 'taskType_semantic_whole_template_ppt';
    // },
    // isOnePageTemplate() {
    //   return this.selectedTaskType?.id === 'task_one_page_template';
    // },
    // // 动态排序后的模板类型
    // templateTypes() {
    //   // 获取当前选中的任务类型，如果没有则返回原始顺序
    //   const priorityType = this.selectedTaskType;
    //   if (!priorityType) return this.rawTemplateTypes;
      
    //   // 排序逻辑：如果是全PPT模板类型，将semantic_whole排在最前面
    //   return [...this.rawTemplateTypes].sort((a, b) => {
    //     if (this.isWholeTemplate) {
    //       return a.type === 'semantic_whole' ? -1 : 1;
    //     }
    //     if (this.isOnePageTemplate) {
    //       return a.type === 'semantic_one_page' ? -1 : 1;
    //     }
    //     // 默认排序逻辑
    //     if (!priorityType) return 0;
    //     return a.type === priorityType ? -1 : 1;
    //   });
    // }  
  },
  //监控data中数据变化
  watch: {
    selectFile(file) {
      if (file) {
        publish(actionMenuPubIds.pubId_Action_Menu_PPT_From_File_header_action, this.selectFile)
      }
      this.selectFile = null
    },
    tab: {
      handler(newValue) {
        // semantic template
        localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic, JSON.stringify(newValue == 0))
      },  
      immediate: true  
    },
    // selectedItem(newValue) {
    //   console.log('selectedItem', newValue);
      
    //   // 选中的模板ID，插入一页新的Slide或者更新当前的Slide
    //   localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic, JSON.stringify(this.templateTypes[this.tab].type === 'semantic_one_page'))
    //   localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic_whole, JSON.stringify(this.templateTypes[this.tab].type === 'semantic_whole'))
    //   if (newValue >= 0) {
    //     if(this.tab === 0) {
    //       if (this.selectedTaskType.id != 'taskType_semantic_whole_template_ppt') {
    //         this.$message.warning(i18n.t('ppt_add_in_main.txt_remind_pls_select_template_whole_task_type'))
    //       } else {
    //         preViewTemplate(store.get("gpt/currentPreviewSlideId"), this.templateTypes[this.tab].templates[newValue].fileName)
    //       }
    //     } else {
    //       if (this.selectedTaskType.id === 'taskType_semantic_whole_template_ppt') {  
    //         this.$message.warning(i18n.t('ppt_add_in_main.txt_remind_pls_select_template_onepage_task_type'))
    //       } else {
    //         preViewTemplate(store.get("gpt/currentPreviewSlideId"), this.templateTypes[this.tab].templates[newValue].fileName)
    //       }
    //     }
    //   }
    // } 
  },
  methods: {
    handleIndexChange(newValue) {
      // 处理选中项变化的逻辑
      this.selectedItem = newValue;
      localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic, JSON.stringify(this.templateTypes[this.tab].type === this.TEMPLATE_TYPE_NAME_SEMANTIC_ONE_PAGE))
      localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic_whole, JSON.stringify(this.templateTypes[this.tab].type === this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE))
      if (newValue >= 0) {
        if(this.templateTypes[this.tab].type === this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE) {
          if (this.selectedTaskType.id != 'taskType_semantic_whole_template_ppt') {
            this.$message.warning(i18n.t('ppt_add_in_main.txt_remind_pls_select_template_whole_task_type'))
          } else {
            preViewTemplate(store.get("gpt/currentPreviewSlideId"), this.templateTypes[this.tab].templates[newValue].fileName)
          }
        } else {
          if (this.selectedTaskType.id === 'taskType_semantic_whole_template_ppt') {  
            this.$message.warning(i18n.t('ppt_add_in_main.txt_remind_pls_select_template_onepage_task_type'))
          } else {
            preViewTemplate(store.get("gpt/currentPreviewSlideId"), this.templateTypes[this.tab].templates[newValue].fileName)
          }
        }
      }
    },
    saveSettings() {
      if (this.selectedItem >= 0) {
        if(this.templateTypes[this.tab].type === this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE && this.selectedTaskType.id != 'taskType_semantic_whole_template_ppt') { 
          this.$message.warning(i18n.t('ppt_add_in_main.txt_remind_pls_select_template_whole_task_type'))
        } else {
          if (this.templateTypes[this.tab].type != this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE && this.selectedTaskType.id === 'taskType_semantic_whole_template_ppt') {
            this.$message.warning(i18n.t('ppt_add_in_main.txt_remind_pls_select_template_onepage_task_type'))
          } else {
            localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic_whole, JSON.stringify(this.templateTypes[this.tab].type === this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE))
            localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic, JSON.stringify(this.templateTypes[this.tab].type === this.TEMPLATE_TYPE_NAME_SEMANTIC_ONE_PAGE))
            if (!store.get('gpt/currentPreviewSlideId') || !store.set('gpt/currentSelectedTemplateName')) {
              // if (this.templateTypes[this.tab].type != this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE) {
                preViewTemplate(store.get("gpt/currentPreviewSlideId"), this.templateTypes[this.tab].templates[this.selectedItem].fileName)
              // }
            }
            store.set('gpt/currentSelectedTemplateName', this.templateTypes[this.tab].templates[this.selectedItem].fileName)
            this.$emit('selectedTemplate', i18n.t('ppt_add_in_main.btn_select_template'))
            savePreviewTemplateShapeData()
            this.dialog = false
          }
        }
      } else {
        this.$message.warning(i18n.t('ppt_add_in_main.msg_pls_select_template'))
      }
    },
    clearSelected(){
      store.set('gpt/currentPreviewSlideId', null)
      store.set('gpt/currentSelectedTemplateName', null)
      store.set('gpt/currentSelectedSemanticTemplateWhole', null)
      this.$emit('selectedTemplate', i18n.t('ppt_add_in_main.btn_select_template_default'))
      this.dialog = false
    },
    clickCloseSettings() {
      if (JSON.parse(localStorage.getItem(userKeys.key_user_generate_slide_is_change_one_page_template))) {
        store.set("gpt/selectedTaskType", null);
        store.set("gpt/selectedTaskOptions", null);

        store.set("gpt/hideAutoActionType", true);
        store.set("gpt/autoActionTypeFirst", null);
        store.set("gpt/autoActionTypeSecond", null);
        store.set("gpt/autoActionType", null)
      }
      this.dialog = false
    },
    clickShowDialog() {
      this.dialog = true
      localStorage.setItem(userKeys.key_user_settings_select_template_is_semantic, JSON.stringify(false))
    },
    updateListMaxHeight() {  
      this.$forceUpdate(); 
    }, 
    enter(index) {
      this.showDes = true
      this.desShowIndex = index
    },
    leave() {
      this.showDes = false
      this.desShowIndex = -1
    },
    // previewWholeSemanticTemplate(index) {
    //   // preViewTemplate(store.get("gpt/currentPreviewSlideId"), this.templateTypes[this.tab].templates[this.selectedItem].fileName)
    // }
  },
  beforeDestroy() {
    window.addEventListener('resize', this.updateListMaxHeight); 
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() { 
    this.templateTypes.find(item => item.type === this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE).templates = this.template_semantic_whole
    this.templateTypes.find(item => item.type === this.TEMPLATE_TYPE_NAME_SEMANTIC_ONE_PAGE).templates = this.template_semantic
    this.templateTypes.find(item => item.type === this.TEMPLATE_TYPE_NAME_SYS_ONE_PAGE).templates = this.template_title_contents.filter(item => item.fileName.includes('textonly_title_content'))
    // let enterpriseUnitName = ''
    // if (localStorage.getItem(userKeys.key_login_AccountName)) {
    //   const match = localStorage.getItem(userKeys.key_login_AccountName).match(/@([^@]+)\.com/)
    //   enterpriseUnitName = match ? match[1] : ''
    // }
    // enterpriseUnitName = 'deloitte'
    // this.templateTypes[2].templates = this.template_title_contents.filter(item => item.fileName.toLowerCase().includes(enterpriseUnitName.toLowerCase()))

    // 如果是C端用户，不显示企业模板，只显示语义模板和视觉模板和将来的布局模板，顺序是布局、视觉、语义
    if (isEqualGuidString(localStorage.getItem(userKeys.key_corporationId), appIds.individual_corporation_id)) {
      this.templateTypes = this.templateTypes.filter(item => item.type !== this.TEMPLATE_TYPE_NAME_SEMANTIC_WHOLE);
      // 将语义模板放在最后
      const semanticIndex = this.templateTypes.findIndex(item => item.type === this.TEMPLATE_TYPE_NAME_SEMANTIC_ONE_PAGE);
      if (semanticIndex > -1) {
        const [semanticTemplate] = this.templateTypes.splice(semanticIndex, 1);
        this.templateTypes.push(semanticTemplate);
      }
    }
  },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    window.addEventListener('resize', this.updateListMaxHeight); 
  },
  destroyed() { }, //生命周期-销毁完成
  activated() { }, //如果页面有keep-alive,这函数会触发
}
</script>